import { useQuery } from "react-query";

import {
  getStores,
  getPriceLists,
  getArticles,
  getMeasureUnits,
  getEmployeesGroups,
  getOperationTypes,
} from "./requests";

const STALE_TIME = 60 * 1000;

export const useStores = (options) =>
  useQuery(["stores"], () => getStores(), {
    staleTime: STALE_TIME,
    ...options,
  });

export const usePriceLists = (options) =>
  useQuery(["pricelists"], getPriceLists, { staleTime: STALE_TIME, ...options });

export const useArticles = (options) =>
  useQuery(["articles"], () => getArticles(), {
    staleTime: STALE_TIME,
    ...options,
  });

export const useMeasureUnits = (options) =>
  useQuery(["measure-units"], getMeasureUnits, {
    staleTime: STALE_TIME,
    ...options,
  });

export const useEmployeesGroups = (options) =>
  useQuery(["employees-groups"], getEmployeesGroups, options);

export const useOperationTypes = (options) =>
  useQuery(["operation-types"], getOperationTypes, {
    staleTime: STALE_TIME,
    ...options,
  });
